import React from 'react';

import Select, { selectType } from 'Components/Select';
import RowsSelector from 'Components/RowsSelector';
import YearPicker from 'Components/YearPicker';

export default ({
  outCount,
  handleRowCountSelect,
  rowsCount,
  handleSelectFilter,
  filterState,
  currentYear,
  documentTypes,
  handleYearSelect,
  chosenYear,
}) => {
  const DOCUMENTS_STATUSES = [
    { name: 'All', value: 'All' },
    { name: 'Sent', value: 'sent' },
    { name: 'Completed', value: 'completed' },
    { name: 'Voided', value: 'voided' },
    { name: 'Delivered', value: 'delivered' },
    { name: 'Declined', value: 'declined' },
  ];

  const getSelectedItem = (key, possibleItemsList) => {
    if (filterState[key] === undefined) return possibleItemsList[0];
    return possibleItemsList.find(item => (item.value || item) === filterState[key]);
  };

  return (
    <section className='list-scene__utility-section-wrapper'>
      <section className='list-scene__utility-section-filters-wrapper'>
        <div className='list-scene__utility-section-filters-header'>Filter</div>
        <YearPicker
          endYear={currentYear + 1}
          yearPickAction={handleYearSelect}
          label='by Year'
          year={chosenYear}
          width={160}
          height={18}
        />

        <Select
          selectionList={DOCUMENTS_STATUSES}
          handleSelect={handleSelectFilter('status')}
          placeholder='All'
          defaultItem={getSelectedItem('status', DOCUMENTS_STATUSES)}
          label='by Status'
          itemNameIndicator='name'
          type={selectType.listFilter}
        />

        <Select
          selectionList={documentTypes}
          handleSelect={handleSelectFilter('typeTitle')}
          placeholder='All'
          defaultItem={getSelectedItem('typeTitle', documentTypes)}
          label='by Type'
          type={selectType.listFilter}
        />
      </section>

      <section className='list-scene__utility-section-rows-select-wrapper'>
        <RowsSelector allRowsCount={outCount} handleRowsSelect={handleRowCountSelect} selectedRowsCount={rowsCount} />
      </section>
    </section>
  );
};



// WEBPACK FOOTER //
// ./src/app/Scenes/DocumentsList/FiltersSection.jsx